import {useMutation} from "@tanstack/react-query";
import {cancelCustomerOfferMutationOptions} from "./cancel-customer-offer.mutation-options";

export function useCancelCustomerOffer() {
  return useMutation(cancelCustomerOfferMutationOptions());
}
